import React from 'react';
import { useDispatch } from 'react-redux';
import { setSlideKey } from 'store/onboarding';
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import getOnboardingTasks from 'fetches/getOnboardingTasks';
import useTask from 'components/onboarding/useTask';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import TaskDetailHeading from 'components/onboarding/TaskDetailHeading';

function CompletionCheers() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const taskToShow = useTask();

  if (!taskToShow) {
    return null;
  }

  const handleBackToList = () => {
    dispatch(setSlideKey('list'));
    dispatch(getOnboardingTasks());
  };

  return (
    <>
      <TaskDetailHeading />
      <div className={classes.root}>
        <div className={classes.container}>
          <Typography className={classes.headline}>
            Congrats you have completed “{taskToShow.title}”!
          </Typography>
          <CheckCircleIcon
            fontSize={'inherit'}
            className={classNames(classes.checkIcon, classes.checked)}
          />
          <Button color="secondary" variant="contained" size="large" onClick={handleBackToList}>
            Back to task list
          </Button>
        </div>
      </div>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 400,
  },
  container: {
    width: 258,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  headline: {
    // @ts-ignore
    ...theme.typography.h5Semibold,
    textAlign: 'center',
  },
  checkIcon: {
    fontSize: 120,
    margin: theme.spacing(5.5),
  },
  checked: {
    color: theme.palette.success.main,
  },
}));

export default CompletionCheers;
